<div class="chatbot-icon" (click)="toggleChatbot()">
  <i class="fa fa-comments"></i>
</div>

<!-- Chatbot Window -->
<div class="chatbot-window" [ngClass]="isLoggedIn ? 'chatbot-login' : 'chatbot-guest'" *ngIf="showChatbot">
  <div class="chatbot-header">
    <span>AI Helpdesk</span>
    <button type="button" class="close-btn" (click)="toggleChatbot()">×</button>
  </div>

  <div class="chatbot-content">

    <!-- Loader overlay: shown while API call is in progress -->
    <div class="loader-overlay" *ngIf="isIframeLoading && !iframeError">
      <div class="spinner"></div>
      <p class="loader-text">Loading Helpdesk...</p>
    </div>

    <!-- Error state: shown when API returns an error or network fails -->
    <div class="error-overlay" *ngIf="iframeError && !isIframeLoading">
      <div class="error-icon">
        <i class="fa fa-exclamation-circle"></i>
      </div>
      <div class="error-status-badge" *ngIf="iframeErrorStatus">
        {{ iframeErrorStatus }}
      </div>
      <p class="error-title">Something went wrong</p>
      <p class="error-message">{{ iframeError }}</p>
      <button class="retry-btn" (click)="setChatbotUrl()">
        <i class="fa fa-refresh"></i> Retry
      </button>
    </div>

    <!-- Iframe: rendered only once URL is successfully fetched -->
    <iframe
      *ngIf="chatbotUrl && !iframeError"
      [src]="chatbotUrl"
      id="chatbotFrame"
      (load)="onIframeLoad()"
      [style.transform]="'scale(' + iframeScale + ')'"
      [style.width]="(100 / iframeScale) + '%'"
      [style.height]="(100 / iframeScale) + '%'"
      style="transform-origin: top left; border: 0;"
      frameborder="0"
    ></iframe>

  </div>
</div>
